import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./Context/AuthContext";

export default function PrivateRoute({ children }) {
  const { user, loadingAuth } = useContext(AuthContext);

  if (loadingAuth) return null;

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
}